import { createAuth0 } from "@auth0/auth0-vue";
import { SSOConfig } from "@telegraphio/bapi-types";
import { App } from "vue";

export function createAuth0App(app: App, config: SSOConfig) {
  if (config.auth.provider !== "auth0") return app;

  const plugin = createAuth0({
    domain: config.auth.issuer.slice(-1) === "/" ? config.auth.issuer.slice(0, -1) : config.auth.issuer,
    clientId: config.auth.client_id,
    authorizationParams: {
      redirect_uri: config.auth.redirect_uri,
    },
  });
  app.use(plugin);
}
